import React from 'react';
import './TenderProcurement.css';

const TenderProcurement = () => {
  return (
    <div className="tender">
      <div className="tender-wrapper">
        <h2 className="tender-title">📑 Tenders & Procurement</h2>
        <p className="tender-intro">
          At Igbo-Eze North Local Government Council, transparency, fairness, and value-for-money are the cornerstones of our procurement process. We welcome bids from qualified contractors, vendors, and consultants for the execution of projects and supply of goods and services that support our 2025–2029 Medium Term Development Plan.
        </p>

        <section className="tender-section">
          <h3>🏗️ Current Opportunities</h3>
          <ul>
            <li>Open tenders and requests for proposals (RFPs)</li>
            <li>Procurement notices for construction, supplies, and consultancy</li>
            <li>Pre-qualification requirements and submission deadlines</li>
            <li>Contact details for bid inquiries and clarifications</li>
          </ul>
          {/* <p><strong>👉 Click here to view or download active tenders.</strong></p> */}
        </section>

        <section className="tender-section">
          <h3>📋 Procurement Process</h3>
          <p>We follow due process in line with:</p>
          <ul>
            <li>The Public Procurement Guidelines of Enugu State</li>
            <li>The Local Government By-Law on procurement and project funding</li>
            <li>Financial rules and audit oversight by the Auditor-General for Local Governments</li>
          </ul>
          <p>Key steps include:</p>
          <ol>
            <li>Advertisement of tenders through the website, notice boards, and local media</li>
            <li>Transparent bidding and evaluation by the Procurement Committee</li>
            <li>Award of contracts based on technical competence, cost-effectiveness, and community impact</li>
            <li>Monitoring and evaluation of project delivery by the PRS Department</li>
          </ol>
        </section>

        <section className="tender-section">
          <h3>🤝 Partnering with Us</h3>
          <ul>
            <li>Reputable local contractors and vendors</li>
            <li>Women- and youth-led enterprises</li>
            <li>NGOs, CBOs, and donor agencies offering technical or financial support</li>
            <li>Public-private partnerships (PPPs) for infrastructure, energy, and service delivery</li>
          </ul>
        </section>

        <p className="tender-conclusion">
          📌 <strong>Important:</strong> All vendors must comply with registration requirements and provide proof of tax clearance, business registration, and relevant certifications.
        </p>

        <p className="tender-contact">
          📧 For procurement-related inquiries, please contact: <strong>procurement@igboezenorth.gov.ng</strong> or visit the Procurement Office at the LG Secretariat.
        </p>
      </div>
    </div>
  );
};

export default TenderProcurement;